export default {"src":"/_next/static/media/nivea_black.c421055d.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};